<template>
  <div class="cascade-checker-wrapper" ref="CascadeChecker">
    <div class="radio-wrapper" v-if="type === 'radio'">
      <rich-radio-group>
        <div v-for="(item, index) in options" :key="'option_' + index">
          <rich-radio :option="item" v-model="checkerValue"></rich-radio>
          <div
            class="matter-wrapper"
            v-if="item.matterOptions && !(item.props && item.props.options)"
            v-show="showSecond(item.value, checkerValue)"
          >
            <matter
              :result="item.value"
              ref="matter"
              :options="item.matterOptions"
              @input="secondMatterChange"
            />
          </div>
          <div
            class="second-item-wrapper"
            v-if="item.props && item.props.options"
            v-show="showSecond(item.value, checkerValue)"
          >
            <second
              ref="second"
              :result="item.value"
              :type="item.props.type"
              :options="item.props.options"
              @input="secondChange"
            ></second>
          </div>
        </div>
      </rich-radio-group>
    </div>
    <div v-else-if="type === 'checkbox'">
      <rich-checkbox-group v-model="checkerList" @input="change">
        <div v-for="(item, index) in options" :key="'option_checkbox' + index">
          <rich-checkbox :option="item"></rich-checkbox>
          <div
            class="matter-wrapper"
            v-if="item.matterOptions && !(item.props && item.props.options)"
          >
            <matter
              ref="matter"
              v-show="showSecond(item.value, checkerList)"
              :result="item.value"
              :options="item.matterOptions"
              @input="secondMatterChange"
            />
          </div>
          <div
            class="second-item-wrapper"
            v-if="item.props && item.props.options"
            v-show="showSecond(item.value, checkerList)"
          >
            <second
              ref="second"
              :second="secondValue[item.value]"
              :result="item.value"
              :type="item.props.type"
              :options="item.props.options"
              @input="secondChange"
            ></second>
          </div>
        </div>
      </rich-checkbox-group>
    </div>
    <div
      class="error-msg"
      v-if="showErr"
      v-text="errmsg"
    ></div>
  </div>
</template>
<script>
/**
 * 两级(单选、多选)联动组件
 * 目前应用于 新建拜访的 拜访结果部分
 * 支持 单选 -> 单选，单选 -> 多选，多选 -> 单选，多选 -> 多选
 * 二级还支持 选中后的备注功能 或者如重复门店的 门店ID的input校验等复杂功能
 * props: {
 *  type: checkbox / radio,
 *  options: [{
      label: i18n.gettext('重复门店'),
      value: 7,
      props: {
        needOther: true,
        config: [{
          type: 'input', // textarea | input 默认 textarea
          prop: 'other',
          otherValue: '',
          placeholder: i18n.gettext('请输入门店ID')
        }],
        // rules 支持的形式有限 参考 custom 形式 不支持异步校验
        rules: [ shopIdCascade( i18n.gettext('门店ID'), {gettext: i18n.gettext, sprintf: sprintf} ) ]
      }
    }]
 * }
 * validate 校验函数 支持cb 和 返回 promise 两种方式
 */
import { isArray } from 'lodash-es'
import second from './CascadeSecondChecker.vue'
import matter from './CascadeMatterChecker.vue'
import { mapState, mapMutations } from 'vuex'
// 取消选中之后  delete 相应数据
export default {
  name: 'CascadeChecker',
  props: {
    value: {
      required: false,
      type: [String, Array, Object]
    },
    type: {
      required: false,
      type: String, // checkbox radio
      default: 'radio'
    },
    options: {
      required: true,
      type: Array
    }
  },
  components: {
    second,
    matter
  },
  data () {
    return {
      checkerValue: '',
      checkerList: [],
      secondValue: {},
      showErr: false,
      errmsg: this.gettext('选项和输入框不能为空')
    }
  },
  watch: {
    value (nVal) {
      this.initValue(nVal, true)
    },
    checkerValue (nVal, oVal) {
      this.updateInvalidOpportunity(nVal)
      nVal !== oVal && this.change()
    },
    visitType (nVal) {
      this.showErr = false
    }
  },
  computed: {
    ...mapState('visit', {
      visitType: (state) => state.visitType
    })
  },
  created () {
    this.initValue(this.value)
  },
  methods: {
    ...mapMutations('visit', [
      'updateInvalidOpportunity'
    ]),
    initValue (value, reset) {
      if (!value && reset) {
        this.checkerValue = ''
        this.checkerList = []
        this.initSecondValue(true)
      } else if (!reset && value) {
        if (this.type === 'radio') {
          this.checkerValue = value.value[0] || ''
        } else {
          this.checkerList = value.value || []
        }
        this.secondValue = value.second || {}
        this.initSecondValue()
      }
    },
    initSecondValue (reset = false) {
      let secondValueKeys = Object.keys(this.secondValue)
      let secondDomList = this.$refs.second
      if (secondValueKeys.length && secondDomList && secondDomList.length) {
        secondValueKeys.forEach((key) => {
          let second = secondDomList.find((item) => {
            return item.result === key - 0
          })
          if (second) {
            let secondValue = this.secondValue[key]
            second.initValue(reset, secondValue)
          }
        })
      }
      if (reset) {
        this.secondValue = {}
      }
    },
    showSecond (value, checkerValue) {
      return isArray(checkerValue)
        ? checkerValue.includes(value)
        : checkerValue === value
    },
    getValue () {
      return this.type === 'radio'
        ? this.checkerValue
          ? [this.checkerValue]
          : []
        : this.checkerList
    },
    change () {
      let value = this.getValue()
      if (value.length) {
        this.showErr = false
      } else {
        this.showErr = true
      }
      this.$emit('input', {
        value: value,
        second: this.secondValue
      })
    },
    secondMatterChange (data = {}) {
      const secondValue = this.secondValue[data.result]
      if (!secondValue) {
        this.secondValue[data.result] = data
      } else {
        this.secondValue[data.result] = {
          ...secondValue,
          ...data
        }
      }
      this.change()
    },
    secondChange (data) {
      // 二级联动 change
      this.secondValue[data.result] = data
      let value = this.getValue()
      this.$emit('input', {
        value: value,
        second: this.secondValue
      })
    },
    async validate (cb) {
      // 校验second
      let refSecondList = this.$refs.second || []
      const refMattterList = this.$refs.matter || []
      let value = this.getValue()
      let validateStatus = true
      let secondValid = true
      let matterValid = true

      for (let i = 0; i < value.length; i++) {
        let key = value[i]
        let refSecond = refSecondList.find((item) => {
          return item.result === key
        })
        // 聚合所有的状态
        if (refSecond) {
          let tempValid = await refSecond.validate((res) => {
            validateStatus && (validateStatus = res)
          })
          if (secondValid) {
            secondValid = tempValid
          }
        }
        const refMatter = refMattterList.find(item => item.result === key)
        if (refMatter) {
          let tempValid = await refMatter.validate((res) => {
            validateStatus && (validateStatus = res)
          })
          if (matterValid) {
            matterValid = tempValid
          }
        }
      }
      const filterValue = value.filter(item => item)
      if (filterValue.length === 0) {
        validateStatus = false
        this.showErr = true
      }
      cb && validateStatus && secondValid && matterValid && cb(validateStatus)
      return secondValid && matterValid && validateStatus
    }
  }
}
</script>
<style lang="stylus" scoped>
.cascade-checker-wrapper {
  .second-item-wrapper {
    padding-left: 30px;
  }

  .matter-wrapper {
    padding-left: 30px;
  }
}
.error-msg {
  padding: 0 30px 40px;
  margin-top: 3px;
  font-size: 24px;
  color: #e64340;
}
</style>
